import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './PreferenceTooltip.css';

interface PreferenceTooltipProps {
  /** Whether to show the tooltip */
  visible: boolean;
  /** Called when tooltip is dismissed */
  onDismiss: () => void;
  /** Auto-dismiss after N ms (default: 4000) */
  autoDismissMs?: number;
}

const PreferenceTooltip: React.FC<PreferenceTooltipProps> = ({
  visible,
  onDismiss,
  autoDismissMs = 4000,
}) => {
  const { t } = useTranslation('placementTest');
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (visible) {
      // Small delay so it appears after modal closes
      const showTimer = setTimeout(() => setShow(true), 300);
      const dismissTimer = setTimeout(() => {
        setShow(false);
        setTimeout(onDismiss, 300); // Wait for fade-out animation
      }, autoDismissMs);

      return () => {
        clearTimeout(showTimer);
        clearTimeout(dismissTimer);
      };
    } else {
      setShow(false);
    }
  }, [visible, autoDismissMs, onDismiss]);

  const handleClick = () => {
    setShow(false);
    setTimeout(onDismiss, 200);
  };

  if (!visible && !show) return null;

  return (
    <div
      className={`pref-tooltip-overlay ${show ? 'pref-tooltip-overlay--visible' : ''}`}
      onClick={handleClick}
    >
      <div className="pref-tooltip">
        <div className="pref-tooltip-arrow" />
        <p className="pref-tooltip-text">
          {t('inputMode.tooltipHint')}
        </p>
        <span className="pref-tooltip-tap">
          {t('inputMode.tapToDismiss')}
        </span>
      </div>
    </div>
  );
};

export default PreferenceTooltip;
